<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="dialogVisible" ref="modal">        
        <div class="u-window m-order-modal">           
            <div class="u-btn close" @click="destroyElement"></div>
            <div class="dialog-wrapper">
                <div class="t-order"></div>
                <p>下单时间：{{ data.settleTime }}</p>
                <p>订单编号：{{ data.orderId }}  <em class="u-btn copy" data-clipboard-action="copy" v-bind:data-clipboard-text="data.orderId" @click="copy">复制</em></p>
                <div class="discount-detail">
                    <ul>
                        <li class="clearfix" v-for="(player,index) in data.list" :key="index">
                            <div class="player-name f-l">
                                {{ player.name }}
                                <em class="icon-first" v-if="player.mode == 1"></em>
                                <em class="icon-best" v-if="player.mode == 2"></em>
                            </div>
                            <div class="cnt f-r">
                                <em class="icon-m3b"></em>
                                {{ player.discount }}
                            </div>
                        </li>
                        <li v-if="data.list.length < 4" v-for="n in (4 - data.list.length)"></li>
                    </ul>
                </div>
                <button class="u-btn read" @click="destroyElement"></button>
            </div>       
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<script>
export default {
    data () {
        return {
            dialogVisible : false,
            data: () => {},
            price: 0,
            shareTxt: '加载中',
            key: '',
        }
    },
    created (){
        //this.render();
    },
    methods : {
        destroyElement () {
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },
        copy() {
            //复制链接
            let _this = this;
            let clipboard = new _this.clipboard(".copy");
            clipboard.on('success', function () {
              _this.$toast("复制成功");
            });
            clipboard.on('error', function () {
              _this.$toast("复制失败");
            });
            //_this.destroyElement();
        },            
    },
}
</script>

<style scoped>
/* order */
.m-order-modal {
    width: 709px;
    /* height: 5.47rem; */
    background-image: url(~@/assets/images/utils/modal-buy.png);
}

.t-order {
    width: 293px;
    height: 54px;
    margin: 0 auto 15px;
    background-image: url(~@/assets/images/utils/title-order-detail.png);
}

.m-order-modal p{
    width: 615px;
    margin: 0 auto 12px;
    padding-left: 30px;
    box-sizing: border-box;
}

.m-order-modal .u-btn.copy{
    color: #d33d27;
    text-decoration: underline;
}

.u-btn.read{
    width: 244px;
    height: 74px;
    margin: 0 auto;
    background-image: url(~@/assets/images/utils/btn-dis-close.png);
}

.m-order-modal .discount-detail{
    margin: 20px auto;
}

.discount-detail{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    height: 270px;
}

.discount-detail ul{
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/OrderDetail/orderDetail.vue